import { AbstractClient, CompositionClient } from "@/app/client";

export interface StorageUploadResponse {
  url: string;
  filename: string;
  size: number;
}

export default class APIStorageSub extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  async upload(file: File): Promise<StorageUploadResponse> {
    const formData = new FormData();
    formData.append("file", file);

    const response = await this._fetch({
      method: "POST",
      url: "/storage/upload",
      body: formData as any,
      bodyMime: "multipart/form-data",
      auth: ["OAuth2PasswordBearer"],
    });
    if (response.headers.get("Content-Type") === "application/json") {
      return response.json();
    }
    throw new Error("Bad content type");
  }

  async uploadMultiple(files: File[]): Promise<StorageUploadResponse[]> {
    const uploads = files.map((file) => this.upload(file));
    return Promise.all(uploads);
  }
}
